if (!customElements.get("bag-weights-table")) {
  class BagWeightsTable extends HTMLElement {
    connectedCallback() {
      this.addEventListener("change", (e) => {
        if (e.target.name !== "bag_weight_option") return;
        const row = e.target.closest("tr");
        if (row) this._updatePrice(row.dataset.price);
      });

      const checked = this.querySelector('input[name="bag_weight_option"]:checked');
      if (checked) {
        const row = checked.closest("tr");
        if (row) this._updatePrice(row.dataset.price);
      }
    }

    _updatePrice(price) {
      const productPage = this.closest("product-page");
      if (!productPage) return;
      for (const sel of [
        '[data-update-block="price-compact"] .product-price--original',
        '[data-update-block="price-extended"] .product-price--original',
      ]) {
        const el = productPage.querySelector(sel);
        if (el) el.textContent = price;
      }
    }
  }

  customElements.define("bag-weights-table", BagWeightsTable);
}
